import { createSelector } from 'reselect';

import selectCart from '../select-cart';
import selectProducts from '../select-products';

const selectCartHospitalOrPackageProduct = createSelector([selectCart, selectProducts], (cart, products) => {
  const hospitalId = cart?.hospital?.id;
  const packageId = cart?.package?.id;
  return products?.[packageId || hospitalId] ?? null;
});

export default selectCartHospitalOrPackageProduct;
